<template>
  <div>
    <div class="row mar-b30">
      <div class="col-xs-3" v-if="columnSelect">Column</div>
      <div :class="{'col-xs-3': columnSelect, 'col-xs-3': !columnSelect}" class="col-xs-2">Operator</div>
      <div :class="{'col-xs-2': columnSelect, 'col-xs-4': !columnSelect}">Value</div>
      <div class="col-xs-3">Colour</div>
      <div class="col-xs-1"></div>
    </div>
    <div v-for="(alarm, index) in panel.alarms" :key="index" class="row mar-b30">
      <div v-if="columnSelect" class="col-xs-3">
        <div class="form-group">
          <select v-model="alarm.column">
            <option value>-- Select Column --</option>
            <option v-for="(option, index) in definition.formattingOptions" :key="index" :value="option.name">{{option.label}}</option>
          </select>
        </div>
      </div>
      <div :class="{'col-xs-3': columnSelect, 'col-xs-3': !columnSelect}">
        <div class="form-group">
          <select v-model="alarm.operator">
            <option value>-- Select Operator --</option>
            <option v-for="(option, index) in getOperators(alarm)" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
      <div :class="{'col-xs-2': columnSelect, 'col-xs-4': !columnSelect}">
        <div class="form-group">
          <input v-if="getType(alarm) === 'string'" type="text" v-model="alarm.value">
          <input v-if="getType(alarm) === 'number'" type="number" v-model="alarm.value">
          <masked-input v-if="getType(alarm) === 'duration'" v-model="alarm.friendlyValue" mask="11:11:11" placeholder="HH:MM:SS" @input="() => convert(alarm)"/>
          <datetime v-if="getType(alarm) === 'epoch'" v-model="alarm.friendlyValue" placeholder="HH:MM:SS" @change="convert(alarm)"/>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="form-group">
          <select v-model="alarm.backgroundColour">
            <option value>-- Colour --</option>
            <option v-for="(option, index) in colours.arr" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
      <div class="col-xs-1 controls">
        <span class="fas fa-trash" @click="removeAlarm(index)"></span>
      </div>
    </div>
    <div class="row mar-b30">
      <div class="col-xs-12">
        <button @click="addAlarm()" class="btn btn-md primary">Add Alarm</button>
      </div>
    </div>
  </div>
</template>

<script>
import MaskedInput from "vue-masked-input";
import moment from "moment";
import colours from "../../../utils/colours";
export default {
  components: { MaskedInput },
  props: ["definition", "panel"],
  data() {
    return {
      colours,
      columnSelect: this.definition && this.definition.panelType === "list",
      universalOperators: [{ label: "Equals", value: "equals" }, { label: "Not Equals", value: "no equal" }],
      integerOperators: [{ label: "Greater Than", value: "greater than" }, { label: "Greater Than or Equal", value: "greater than or equal" }, { label: "Less Than", value: "less than" }, { label: "Less Than or Equal", value: "less than or equal" }]
    };
  },
  created() {
    if (!this.panel.alarms || !this.panel.alarms.length) {
      this.panel.alarms = [];
      this.addAlarm();
    }
  },
  methods: {
    removeAlarm(index) {
      this.$delete(this.panel.alarms, index)
    },
    addAlarm() {
      if (!this.panel.alarms) this.panel.alarms = [];
      this.panel.alarms.push({
        operator: "",
        column: "",
        value: undefined,
        friendlyValue: undefined,
        backgroundColour: "",
        colour: "",
        pulse: true
      });
    },
    convert(alarm) {
      if (alarm.friendlyValue) {
        if (alarm.column) {
          let column = this.definition.formattingOptions.find(o => o.name == alarm.column);
          if (column) {
            if (column.type === "duration") {
              // use moment to convert HH:MM:SS to seconds
              let m = moment(alarm.friendlyValue, "HH:mm:ss");
              if (m.isValid()) alarm.value = m.diff(moment().startOf("day"), "seconds");
            }
          }
        } else {
          if ((this.definition && this.definition.formattingOptions && this.definition.formattingOptions.type === "duration") || this.panel.type === "timepanel") {
            let m = moment(alarm.friendlyValue, "HH:mm:ss");
            if (m.isValid()) alarm.value = m.diff(moment().startOf("day"), "seconds");
          }
        }
      }
    },
    getOperators(alarm) {
      if (alarm.column) {
        let column = this.definition.formattingOptions.find(o => o.name == alarm.column);
        if (column) {
          if (column.type === "string") {
            return this.universalOperators;
          } else {
            return this.universalOperators.concat(this.integerOperators);
          }
        }
      } else {
        if (this.definition && this.definition.formattingOptions) {
          if (this.definition.formattingOptions.type === "number" || this.definition.formattingOptions.type === "duration") {
            return this.universalOperators.concat(this.integerOperators);
          } else {
            return this.universalOperators;
          }
        } else {
          if (this.panel.type === "timepanel") {
            return this.universalOperators.concat(this.integerOperators);
          }
        }
      }

      return this.universalOperators;
    },
    getType(alarm) {
      let type = "string";
      if (alarm.column) {
        let column = this.definition.formattingOptions.find(o => o.name == alarm.column);
        if (column) {
          type = column.type;
        }
      } else {
        if (this.definition && this.definition.formattingOptions) {
          type = this.definition.formattingOptions.type;
        } else {
          if (this.panel.type === "timepanel") {
            type = "duration";
          }
        }
      }
      return type;
    }
  }
};
</script>

<style>
</style>
